"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// text field

const styleOverrides = {
  root: ({
    theme
  }) => ({
    fontSize: theme.typography.body2.fontSize
  })
};
const defaultProps = {
  color: 'inputElements'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiInputLabel.js.map